<mat-form-field appearance="fill">
  <mat-label>{{ texts.report.month | translate }}</mat-label>
  <input
    matInput
    (dateChange)="onChange()"
    [matDatepicker]="dp"
    (keydown.arrowDown)="previousMonth($event)"
    (keydown.arrowUp)="nextMonth($event)"
    [formControl]="date"
  />
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker
    #dp
    startView="year"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, dp)"
    panelClass="example-month-picker"
  >
  </mat-datepicker>
</mat-form-field>
